// @flow

import React from 'react';
import styled, { css } from 'styled-components/macro';
import { ifProp } from 'styled-tools';
import posed, { PoseGroup } from 'react-pose';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import { Notification } from '~/components';

export type NotificationsProps = NotificationsListQuery & {
  onHideNotification: string => void,
  device?: $PropertyType<DeviceQuery, 'device'>,
  orientation?: $PropertyType<DeviceQuery, 'orientation'>,
};

const Item = posed.div({
  enter: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
});

const NotificationsWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  ${ifProp(
    'fullWidth',
    css`
      left: 15px;
      right: 15px;
    `,
    css`
      right: 20px;
    `,
  )};
  /* NOTE: notifications (error, success, warning) must have top z-index value among all containers */
  z-index: 9999;

  .react-notification + .react-notification {
    margin-top: 15px;
  }
`;

export const Notifications = ({
  notificationsList,
  onHideNotification,
  device,
  orientation,
}: NotificationsProps) => {
  const fullWidth = device !== 'desktop' && orientation === 'portrait';

  return (
    <NotificationsWrapper fullWidth={fullWidth}>
      <PoseGroup>
        {(notificationsList || []).map(({ id, message, type, ...rest }) => (
          <Item
            key={`notification__${id}`}
            className="react-notification"
            animateOnMount
          >
            <Notification
              message={<FormattedMessage {...messages[type]} />}
              rawMessage={message}
              type={type}
              {...rest}
              onClose={onHideNotification}
              fullWidth={fullWidth}
            />
          </Item>
        ))}
      </PoseGroup>
    </NotificationsWrapper>
  );
};
